// extracted by mini-css-extract-plugin
module.exports = {"container":"SpanInput_container__15huB","label":"SpanInput_label__2S1tw","input":"SpanInput_input__1fJ01"};